package com.devi3east.bashbuddy.features.app.data

import bashbuddy.composeapp.generated.resources.Res
import bashbuddy.composeapp.generated.resources.cart
import bashbuddy.composeapp.generated.resources.cart_selected
import bashbuddy.composeapp.generated.resources.cart_unselected
import bashbuddy.composeapp.generated.resources.contact_us
import bashbuddy.composeapp.generated.resources.dashboard
import bashbuddy.composeapp.generated.resources.dashboard_filled
import bashbuddy.composeapp.generated.resources.dashboard_outline
import bashbuddy.composeapp.generated.resources.detail
import bashbuddy.composeapp.generated.resources.event_details
import bashbuddy.composeapp.generated.resources.events
import bashbuddy.composeapp.generated.resources.favorite_events
import bashbuddy.composeapp.generated.resources.favorite_filled
import bashbuddy.composeapp.generated.resources.favorite_outline
import bashbuddy.composeapp.generated.resources.home_selected
import bashbuddy.composeapp.generated.resources.home_unselected
import bashbuddy.composeapp.generated.resources.information
import bashbuddy.composeapp.generated.resources.leaderboard
import bashbuddy.composeapp.generated.resources.organization_screen
import bashbuddy.composeapp.generated.resources.privacy_policy
import bashbuddy.composeapp.generated.resources.prize_list
import bashbuddy.composeapp.generated.resources.profile
import bashbuddy.composeapp.generated.resources.profile_selected
import bashbuddy.composeapp.generated.resources.profile_unselected
import bashbuddy.composeapp.generated.resources.reset_password
import bashbuddy.composeapp.generated.resources.search
import bashbuddy.composeapp.generated.resources.search_filled
import bashbuddy.composeapp.generated.resources.search_outline
import bashbuddy.composeapp.generated.resources.sign_in
import bashbuddy.composeapp.generated.resources.sign_in_selected
import bashbuddy.composeapp.generated.resources.sign_in_unselected
import bashbuddy.composeapp.generated.resources.sign_up
import bashbuddy.composeapp.generated.resources.sign_up_selected
import bashbuddy.composeapp.generated.resources.sign_up_unselected
import bashbuddy.composeapp.generated.resources.terms_of_service
import bashbuddy.composeapp.generated.resources.ticket_details
import com.devi3east.bashbuddy.features.detail.navigation.RECIPE_ID_ARG
import com.devi3east.bashbuddy.features.events.detail.navigation.EVENT_ID_ARG
import com.devi3east.bashbuddy.features.events.detail.navigation.EVENT_SLUG_ARG
import com.devi3east.bashbuddy.ticketDetail.navigation.TICKET_ID_ARG
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource

sealed class Screen(
    val route: String,
    val resourceId: StringResource,
    val selectedIcon: DrawableResource? = null,
    val unselectedIcon: DrawableResource? = null,
) {

    data object SignUpScreen : Screen(
        route = "sign_up",
        resourceId = Res.string.sign_up,
        selectedIcon = Res.drawable.sign_up_selected,
        unselectedIcon = Res.drawable.sign_up_unselected
    )

    data object SignInScreen : Screen(
        route = "sign_in",
        resourceId = Res.string.sign_in,
        selectedIcon = Res.drawable.sign_in_selected,
        unselectedIcon = Res.drawable.sign_in_unselected
    )

    data object ResetPasswordScreen : Screen(
        route = "reset_password",
        resourceId = Res.string.reset_password
    )

    data object LeaderboardScreen : Screen(
        route = "leaderboard",
        resourceId = Res.string.leaderboard
    )

    data object InformationScreen : Screen(
        route = "information",
        resourceId = Res.string.information
    )

    data object TermsOfServiceScreen : Screen(
        route = "terms_of_service",
        resourceId = Res.string.terms_of_service
    )

    data object PrivacyPolicyScreen : Screen(
        route = "privacy_policy",
        resourceId = Res.string.privacy_policy
    )

    data object ContactUsScreen : Screen(
        route = "contact_us",
        resourceId = Res.string.contact_us
    )

    data object ProfileScreen : Screen(
        route = "account/profile",
        resourceId = Res.string.profile,
        selectedIcon = Res.drawable.profile_selected,
        unselectedIcon = Res.drawable.profile_unselected
    )

    data object OrganizationScreen : Screen(
        route = "account/organization",
        resourceId = Res.string.organization_screen,
        selectedIcon = Res.drawable.profile_selected,
        unselectedIcon = Res.drawable.profile_unselected
    )

    data object EventsScreen : Screen("events",
        Res.string.events,
        selectedIcon = Res.drawable.home_selected,
        unselectedIcon = Res.drawable.home_unselected
    )

    data object EventDetailScreen : Screen(
        route = "event/{$EVENT_ID_ARG}/{$EVENT_SLUG_ARG}",
        resourceId = Res.string.event_details
    ) {
        fun createRoute(eventId: String, slug: String): String =
            "event/$eventId/$slug"
    }

    data object TicketDetailScreen : Screen(
        route = "ticket/{$TICKET_ID_ARG}",
        resourceId = Res.string.ticket_details
    ) {
        fun createRoute(ticketId: String): String =
            "ticket/$ticketId"
    }

    data object PrizeListScreen : Screen(
        route = "event/{$EVENT_ID_ARG}/{$EVENT_SLUG_ARG}/prizelist",
        resourceId = Res.string.prize_list
    ) {
        fun createRoute(eventId: String, slug: String): String =
            "event/$eventId/$slug/prizelist"
    }

    data object FavoriteEventsScreen : Screen("favorite_events",
        Res.string.favorite_events,
        selectedIcon = Res.drawable.favorite_filled,
        unselectedIcon = Res.drawable.favorite_outline
    )

    data object DashboardScreen : Screen(
        route = "account/dashboard",
        Res.string.dashboard,
        selectedIcon = Res.drawable.dashboard_filled,
        unselectedIcon = Res.drawable.dashboard_outline
    )

    data object CartScreen : Screen("cart",
        Res.string.cart,
        selectedIcon = Res.drawable.cart_selected,
        unselectedIcon = Res.drawable.cart_unselected
    )

    data object StripeSuccessScreen : Screen(
        route = "stripe/success/{sessionId}/{orgId}",
        resourceId = Res.string.cart
    ) {
        fun createRoute(
            sessionId: String,
            orgId: String
        ): String =
            "stripe/success/$sessionId/$orgId"
    }

    data object SearchScreen : Screen("search",
        Res.string.search,
        selectedIcon = Res.drawable.search_filled,
        unselectedIcon = Res.drawable.search_outline
    )

    data object Detail : Screen("detail?$RECIPE_ID_ARG={$RECIPE_ID_ARG}", Res.string.detail)
}